export type FastenerGroup = 'fastener' | 'body';

export interface FastenerDef {
  id: string;
  label: string;
  shortLabel: string;
  group: FastenerGroup;
  description: string;
  rotatable?: boolean;
}

export const FASTENER_CATALOG: FastenerDef[] = [
  {
    id: 'peg',
    label: 'Wooden peg',
    shortLabel: 'PEG',
    group: 'fastener',
    description: 'End view of a driven oak peg',
  },
  {
    id: 'peg-pair',
    label: 'Peg pair',
    shortLabel: '2 PEG',
    group: 'fastener',
    description: 'Typical two-peg joint mark',
  },
  {
    id: 'peg-triple',
    label: 'Peg row',
    shortLabel: '3 PEG',
    group: 'fastener',
    description: 'Three pegs in a line',
  },
  {
    id: 'peg-quad',
    label: 'Peg cluster',
    shortLabel: '4 PEG',
    group: 'fastener',
    description: '2×2 peg pattern',
  },
  {
    id: 'washer-head-screw',
    label: 'Washer-head screw',
    shortLabel: 'WHS',
    group: 'fastener',
    description: 'Washer-head structural screw, end view',
  },
  {
    id: 'fully-threaded-screw',
    label: 'Fully threaded screw',
    shortLabel: 'FTS',
    group: 'fastener',
    description: 'Fully threaded structural screw, end view',
  },
  {
    id: 'peg-body',
    label: 'Peg body',
    shortLabel: 'PEG',
    group: 'body',
    description: 'Peg through the joint in section',
    rotatable: true,
  },
  {
    id: 'washer-head-screw-body',
    label: 'Washer-head screw body',
    shortLabel: 'WHS',
    group: 'body',
    description: 'Washer head, shank, and thread',
    rotatable: true,
  },
  {
    id: 'fully-threaded-screw-body',
    label: 'Fully threaded screw body',
    shortLabel: 'FTS',
    group: 'body',
    description: 'Head and full-length thread',
    rotatable: true,
  },
  {
    id: 'tenon-body',
    label: 'Tenon body',
    shortLabel: 'TEN',
    group: 'body',
    description: 'Tenon in section',
    rotatable: true,
  },
  {
    id: 'through-tenon-body',
    label: 'Through tenon body',
    shortLabel: 'THRU',
    group: 'body',
    description: 'Through tenon exiting the far face',
    rotatable: true,
  },
  {
    id: 'dovetail-body',
    label: 'Dovetail body',
    shortLabel: 'DTL',
    group: 'body',
    description: 'Dovetail tenon in section',
    rotatable: true,
  },
];

const BY_ID = new Map(FASTENER_CATALOG.map(f => [f.id, f]));

export function getFastener(id: string | undefined): FastenerDef | undefined {
  if (!id) return undefined;
  return BY_ID.get(id);
}

export function fastenersByGroup(group: FastenerGroup): FastenerDef[] {
  return FASTENER_CATALOG.filter(f => f.group === group);
}
